import { all, put, takeEvery, call } from 'redux-saga/effects';
import actions from './actions';
import { getRequest, putRequest, patchRequest } from '../../../helpers/axiosClient';



export function* getQuickLinks(params) {
    yield put({
        type: actions.QUICKLINKS_SUCCESS,
        payload: params.menus,
        factBox: params.factBox,
        toggle: params.toggle,
        component: params.component
    });
}

export function* getNotification(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.NOTIFICATION_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        yield put({ type: actions.NOTIFICATION_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* editDetails(params) {
    try {
        let response = '';
        if (params.method === 'put') {
            response = yield call(() => putRequest(`${params.url}`, params.details));
        } else {
            response = yield call(() => patchRequest(`${params.url}${params.id ? '/' + params.id : ''}${params.slug ? '/' + params.slug : ''}`, params.details));
        }

        yield put({
            type: actions.EDIT_NOTIFICATION_SUCCESS,
            payload: params.titleFull ? params.titleFull : `${params.title} updated successfully`,
            data: response.data
        });
    } catch (error) {
        yield put({ type: actions.EDIT_NOTIFICATION_FAILURE, message: error?.response?.data });
        return error;
    }
}


export default function* commonSaga() {
    yield all([
        takeEvery(actions.QUICKLINKS_START, getQuickLinks),
        takeEvery(actions.NOTIFICATION_START, getNotification),
        takeEvery(actions.EDIT_NOTIFICATION_START, editDetails),
       
    ]);
}